// routes

export const HOST_API = 'https://api.bookbase.in/';
export const prodPath='https://secure.ccavenue.com/transaction/transaction.do?command=initiateTransaction&encRequest=';
export const devPath='https://test.ccavenue.com/transaction/transaction.do?command=initiateTransaction&encRequest=';
